import React from "react";
import { Link } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { NotificationContainer, NotificationManager } from "react-notifications";
import { httpClient } from "appUtility/Api";
import { decryptSource, parseSource } from "appUtility/CryptoUtils";

const qs = require("qs");

const DECRYPT_KEY =
  "Kx8mQzR3vNpLw7TnJhYc5FgDbA_20240615093042_7_2_H4sWtRmVn8pQzXkLdCfB2";

class CancellationPolicy extends React.Component {
  constructor(props) {
    super(props);

    const url = new URL(window.location.href);
    const c = url.searchParams.get("c");

    this.state = {
      c: c,
      loading: true,
      error: null,
      policy: null,
      settings: null,
    };
  }

  componentDidMount() {
    if (!this.state.c) {
      this.setState({ loading: false, error: "Invalid cancellation policy link." });
      return;
    }
    this.loadPolicy();
  }

  async loadPolicy() {
    try {
      const source = await decryptSource(this.state.c, DECRYPT_KEY);
      const { appID, memberID, companyID } = parseSource(source);

      httpClient
        .post(
          "/v2/getPolicies.php",
          qs.stringify({
            action: "getPolicies",
            "source[appID]": appID,
            "source[memberID]": memberID,
            "source[companyID]": companyID,
            "source[is_selected]": 1,
          })
        )
        .then(({ data }) => {
          if (data && data.success) {
            this.setState({
              loading: false,
              policy: data.data,
              settings: data.settings,
            });
          } else {
            this.setState({
              loading: false,
              error: "Unable to load cancellation policy.",
            });
          }
        })
        .catch(() => {
          this.setState({
            loading: false,
            error: "Unable to load cancellation policy.",
          });
          NotificationManager.error("Error occurred: please refresh and try again");
        });
    } catch (err) {
      this.setState({ loading: false, error: "Invalid cancellation policy link." });
    }
  }

  renderPolicyHtml() {
    const { policy, settings } = this.state;
    const {
      cancelBeforeValue,
      cancelBeforeUnit,
      cancelCutoffTime,
      cancelFeeValue,
      cancelFeeUnit,
    } = settings;

    // Generate timeTemplate based on selection
    let timeTemplate = "";
    if (cancelBeforeUnit === "hours") {
      const hourText = parseInt(cancelBeforeValue) === 1 ? "hour" : "hours";
      timeTemplate = `we kindly require ${cancelBeforeValue || "_____"} ${hourText} notice for any cancellations or reschedules.`;
    } else {
      // Format cutoff time for display (convert HH:MM:SS to 12-hour format)
      let formattedCutoffTime = cancelCutoffTime || "_____";
      if (cancelCutoffTime && cancelCutoffTime !== "_____") {
        const [hours, minutes] = cancelCutoffTime.split(":");
        let hour = parseInt(hours);
        const ampm = hour >= 12 ? "PM" : "AM";
        hour = hour % 12 || 12;
        formattedCutoffTime = `${hour}:${minutes} ${ampm}`;
      }
      timeTemplate = `notice of cancellation or reschedules must be received by ${formattedCutoffTime} the business day prior.`;
    }

    // Generate feeTemplate based on selection
    let feeTemplate = "";
    if (cancelFeeUnit === "%") {
      feeTemplate = `${cancelFeeValue || "_____"}% of the service cost`;
    } else {
      feeTemplate = `$${cancelFeeValue || "_____"}`;
    }

    const html = policy.policy
      .replace(/{{timeTemplate}}/g, timeTemplate)
      .replace(/{{feeTemplate}}/g, feeTemplate);

    return { __html: html };
  }

  render() {
    const { loading, error, policy, settings } = this.state;

    return (
      <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <div className="app-login-main-content" style={{ maxWidth: 600 }}>
          <div className="app-logo-content d-flex align-items-center justify-content-center">
            <Link className="logo-lg" to="/" title="Mate">
              <img
                src={require("assets/images/logo.png")}
                alt="Mate"
                title="Mate"
              />
            </Link>
          </div>

          <div className="app-login-content">
            <div className="app-login-header mb-4">
              <h1>Cancellation Policy</h1>
            </div>

            {loading && (
              <div className="d-flex justify-content-center">
                <CircularProgress />
              </div>
            )}

            {!loading && error && <p>{error}</p>}

            {!loading && !error && policy && settings && (
              <div dangerouslySetInnerHTML={this.renderPolicyHtml()} />
            )}
          </div>
        </div>

        <NotificationContainer />
      </div>
    );
  }
}

export default CancellationPolicy;
